// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { AlertOctagon } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconAlertOctagon(props: any) {
    return <IconBase icon={AlertOctagon} {...props} />
  }

  export default IconAlertOctagon
  